<template>
  <div id="faqs-template">
    <b-row>
        <b-col xs="12" lg="9" v-if="!hideMenuItems && menuItems" class="pb-4">
            <span v-for="item in menuItems" :key="item.to">
                <router-link tag="a" :to="item.to">
                    {{ item.text }}
                </router-link>
                {{ isLastMenuItem(item) ? '' : '>' }}
            </span>
        </b-col>
        <b-col v-if="!hideSearcher" xs="12" lg="3">
            <base-input v-model="searchText" :placeholder="$t('search')" @keyup:enter="search" >
                <template slot="append">
                    <i @click="search"><b-icon-arrow-right></b-icon-arrow-right></i>
                </template>
            </base-input>
        </b-col>
    </b-row>
    <b-row> 
        <b-col xs="12" lg="3">
            <b-card class="mb-3" v-for="group in visibleFaqs" :key="group.id">
                <template #header>
                    <div :ref="group.id" class="w-100" @click="selectGroup(group)" style="cursor: pointer">
                        {{ group.title }}
                        <span class="float-right">
                            <b-icon-chevron-down v-if="isSelectedGroup(group.id)"></b-icon-chevron-down>
                            <b-icon-chevron-up v-else></b-icon-chevron-up>
                        </span>
                    </div>
                    
                </template>
                <b-collapse :id="group.id" :visible="isSelectedGroup(group.id)">
                    <b-list-group>
                        <b-list-group-item v-for="faq in group.questions" :key="faq.id" @click="selectFaq(faq)" :class="{ 'active': isSelectedFaq(faq.id)}" style="cursor: pointer;">
                            {{ faq.question }}
                        </b-list-group-item>
                    </b-list-group>
                </b-collapse>
            </b-card>
        </b-col>
        <b-col xs="12" lg="9" class="px-0 pt-4 px-md-5 pt-md-0">
            <transition>
                <div :name="selectedFaq.id" v-if="selectedFaq">
                    <h3>{{ selectedFaq.question }}</h3>
                    <p v-html="selectedFaq.answer"></p>
                </div>
            </transition>
        </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardBody, BListGroup, BListGroupItem, BCollapse, BIconChevronDown, BIconChevronUp, BBreadcrumb, BIconArrowRight } from 'bootstrap-vue'
import lunr from 'lunr'

export default {
    name: 'faqs',
    components: {
        BBreadcrumb,
        BCard,
        BCardBody,
        BListGroup,
        BListGroupItem,
        BCollapse,
        BIconChevronDown,
        BIconChevronUp,
        BIconArrowRight
    },
    mounted () {
        this.faqs = this.faqsData
        this.idx = lunr((builder) => {
            builder.ref('id')
            builder.field('question')
            builder.field('answer')
            this.faqs.forEach(group => {
                group.questions.forEach(faq => {
                    builder.add(faq)
                })
            })
        })
        const groupId = this.$route.params.groupId
        const faqId = this.$route.params.questionId
        if (groupId) {
            this.$refs[groupId][0].click()
        } else {
            this.selectGroup(this.visibleFaqs[0])
        }
        if (faqId) {
            this.selectFaq(this.selectedGroup.questions.find(faq => faq.id === faqId))
        } else {
            this.selectFaq(this.selectedGroup.questions.find(faq => !!faq))
        }
    },
    props: {
        hideSearcher: Boolean,
        faqsData: Array,
        hideMenuItems: Boolean
    },
    data () {
        return {
            idx: null,
            selectedFaq: null,
            selectedGroup: null,
            faqs: null,
            searchText: null,
            searchResults: null
        }
    },
    watch: {
    },
    methods: {
        selectFaq (faq) {
						/* this.selectGroup(this.faqs.find(group => group.questions.find(_faq => _faq.id === faq.id))) */
            this.selectedFaq = faq
            /* setTimeout(() => {
                document.querySelector(`[name="${faq.id}"]`).scrollIntoView({ block: 'end', behavior: 'smooth' })
            }, 1) */
            /* this.$router.push(`/faqs/${this.selectedGroup.id}/${faq.id}`) */
        },
        isSelectedFaq (id) {
            return this.selectedFaq && this.selectedFaq.id === id
        },
        selectGroup (group) {
						if (this.isSelectedGroup(group.id)) {
							this.selectedGroup = null
							this.selectedFaq = null
						} else {
							this.selectedGroup = this.isSelectedGroup(group.id) ? null : group
							this.selectedFaq = this.selectedGroup.questions.find(faq => !!faq)
						}
            /* this.$router.push(`/faqs/${group.id}`) */
        },
        isSelectedGroup (id) {
            return this.selectedGroup && this.selectedGroup.id === id
        },
        isLastMenuItem (item) {
            return this.menuItems.indexOf(item) === this.menuItems.length - 1
        },
        search () {
            if (!this.searchText) {
                this.searchResults = null
                return
            }
            const results = this.idx.search(this.searchText)
            this.searchResults = results.map(result => {
                const faq = this.faqs.find(group => group.questions.find(faq => faq.id === result.ref))
                return {
                    id: faq.id,
                    title: faq.title,
                    questions: [faq.questions.find(faq => faq.id === result.ref)]
                }
            })
            this.selectGroup(this.searchResults[0])
        }
    },
    computed: {
        menuItems () {
            let menuItems = [
                {
                    text: this.$t('faqs-title'),
                    to: '/faqs'
                }
            ]
            if (this.selectedGroup) {
                menuItems.forEach(item => {
                    item.active = false
                })
                menuItems.push({
                    text: this.selectedGroup.title,
                    to: `/faqs/${this.selectedGroup.id}`,
                    active: true
                })

								if (this.selectedFaq) {
									menuItems.forEach(item => {
											item.active = false
									})
									menuItems.push({
											text: this.selectedFaq.question,
											to: `/faqs/${this.selectedGroup.id}/${this.selectedFaq.id}`,
											active: true
									})
								}
							}
            return menuItems
        },
				visibleFaqs () {
					return (this.searchResults || this.faqs)
				}
    }
}
</script>

<style lang="scss">
.ctm-container {
    @include container-padding;
}

</style>


// WEBPACK FOOTER //
// src/components/views/FAQs.vue